"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverCombobox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Popover = __importStar(require("@radix-ui/react-popover"));
const cmdk_1 = require("cmdk");
const react_1 = require("react");
const Options_1 = require("./Options");
const constants_1 = require("../../../constants");
const translate_1 = require("../../../translate");
const styles_1 = require("../styles");
const FilterInput_1 = require("./FilterInput");
const Panel = (0, styled_1.default)(cmdk_1.Command)(styles_1.panelStyles);
const PopoverContent = (0, styled_1.default)(Popover.Content, {
    shouldForwardProp: (prop) => prop !== 'compact',
})(({ compact }) => ({
    width: compact ? 'fit-content' : 280,
    zIndex: constants_1.theme.zIndex.popover,
}));
const PopoverCombobox = ({ actionsSlot, alignContent, closeOnSelect, compact, defaultOpen = false, filterPlaceholder, groups, isOpen, noItemsFoundLabel, onOpenChange, onSelect, trigger, type, value, }) => {
    const t = (0, translate_1.useTranslations)();
    const [internalIsOpen, setInternalIsOpen] = (0, react_1.useState)(defaultOpen);
    const setIsOpen = (open) => {
        if (isOpen === undefined) {
            setInternalIsOpen(open);
        }
        onOpenChange?.(open);
    };
    return ((0, jsx_runtime_1.jsxs)(Popover.Root, { open: isOpen ?? internalIsOpen, onOpenChange: setIsOpen, children: [(0, jsx_runtime_1.jsx)(Popover.Trigger, { asChild: true, children: trigger }), (0, jsx_runtime_1.jsx)(Popover.Portal, { children: (0, jsx_runtime_1.jsx)(PopoverContent, { sideOffset: 4, align: alignContent ?? 'start', compact: compact, children: (0, jsx_runtime_1.jsxs)(Panel, { children: [(0, jsx_runtime_1.jsx)(FilterInput_1.FilterInput, { autoFocus: true, placeholder: filterPlaceholder ?? t.ui.filter_ellipsis() }), (0, jsx_runtime_1.jsx)(Options_1.PopoverComboboxOptions, { actionsSlot: actionsSlot, groups: groups, noItemsFoundLabel: noItemsFoundLabel, onSelect: (value) => {
                                    if (closeOnSelect)
                                        setIsOpen(false);
                                    onSelect(value);
                                }, type: type, value: value })] }) }) })] }));
};
exports.PopoverCombobox = PopoverCombobox;
